import {createAsyncThunk} from '@reduxjs/toolkit';
import type {BgRemoverUpsellVariant} from '@Libraries/bg-remover-upsell-experiment.library';
import type {BgRemoverUpsellData} from './bg-remover-upsell-panel.types';

export const getBgRemoverUpsellData = createAsyncThunk('getBgRemoverUpsellData', async (variant: BgRemoverUpsellVariant): Promise<BgRemoverUpsellData> => {
  return (await window.PMW.readLocal('premium/getBgRemoverUpsellDialogData', {variant})) as BgRemoverUpsellData;
});
